module.exports = __webpack_public_path__ + "img/intro-new.0ff19ece.svg";